import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { CalendarGridCardTrigger } from '../CalendarGridCardTrigger'
import { CalendarGridDayPopover } from '../CalendarGridDayPopover'

function CalendarGridDayPopoverTrigger({
  Trigger,
  day,
  dayLoad,
  isDayLoadView,
  items,
  triggerProps,
  onClickItem,
  onClickSecondaryLabel,
}) {
  function renderContent({ onClose }) {
    return (
      <CalendarGridDayPopover
        day={day}
        dayLoad={dayLoad}
        isDayLoadView={isDayLoadView}
        items={items}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
        onClose={onClose}
      />
    )
  }

  return (
    <CalendarGridCardTrigger
      Trigger={Trigger}
      placement={
        isDayLoadView
          ? FLOATING_ELEMENT_PLACEMENT.rightStart
          : FLOATING_ELEMENT_PLACEMENT.bottomStart
      }
      renderContent={renderContent}
      triggerProps={triggerProps}
    />
  )
}

export default CalendarGridDayPopoverTrigger
